<nb-card class="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="camera-outline" status="basic">
        </nb-icon>
        <span class="title" [ngClass]="{ 'title-feature-unavailable' : !this.featureIsAvailable() }">
            {{ 'device.details.camera-preview' | translate }}
        </span>
        <nb-icon icon="question-mark-circle-outline" nbTooltipStatus="control" class="me-2 cursor-help"
            nbTooltip="{{ 'tooltips.camera-preview' | translate }}" nbTooltipPlacement="left">
        </nb-icon>
        <nb-icon class="close" icon="close-outline" (click)="cancel()">
        </nb-icon>
    </nb-card-header>

    <ng-container *ngIf="this.featureIsAvailable()">
        <nb-card-body class="content-body p-0">
            <app-camera-preview [device]="deviceDataToStream()" [cameraPreview]="cameraPreviewData"
                *ngIf="!supportLiveStream" class="camera-preview-modal">
            </app-camera-preview>
            <app-device-live-stream-player [device]="deviceDataToStream()" [currentDate]="currentDate"
                (streamTimeout)="onStreamTimeout($event)" *ngIf="supportLiveStream" class="camera-preview-modal">
            </app-device-live-stream-player>
        </nb-card-body>

        <nb-card-footer class="content-footer">
            <button nbButton class="cancel" [size]="'large'" [status]="'control'" [appearance]="'outline'"
                (click)="cancel()" tabindex="-1">
                {{'common.cancel' | translate}}
            </button>
        </nb-card-footer>
    </ng-container>

    <ng-container *ngIf="!this.featureIsAvailable()">
        <nb-card-body class="content-body-feature-unavailable">
            <app-unavailable-feature [image]="'assets/modals/unavailable-preview.png'"
                attention="{{ 'packets.function-is-not-included-in-your-plan' | translate }} {{'packets.standard' | translate }}."
                descriptionTitle="{{'device.details.camera-preview' | translate}}"
                descriptionContent="{{ 'packets.camera-explanation' | translate }}" (cancelCallback)='cancel()'>
            </app-unavailable-feature>
        </nb-card-body>
    </ng-container>
</nb-card>